import { Machine } from "xstate";

export interface MapMachineSchema {
  states: {
    scan: Record<string, unknown>;
    track: Record<string, unknown>;
    markers: Record<string, unknown>;
    routes: Record<string, unknown>;
    route: Record<string, unknown>;
    geofences: Record<string, unknown>;
    locations: Record<string, unknown>;
    replay: Record<string, unknown>;
    navigate: Record<string, unknown>;
  };
}

export type MapEvents =
  | { type: "SELECT" }
  | { type: "DESELECT" }
  | { type: "CLOSE" }
  | { type: "PIN" }
  | { type: "UNPIN" }
  | { type: "MARK"; data?: any }
  | { type: "LOCATION"; data?: any }
  | { type: "FENCE" }
  | { type: "CANCEL" }
  | { type: "VIEW" }
  | { type: "TRIP" }
  | { type: "NAVIGATE" }
  | { type: "SELECT" };

export interface MapContext {
  selected: string;
}

const mapMachine = Machine<MapContext, MapMachineSchema, MapEvents>({
  id: "map",
  initial: "scan",
  states: {
    scan: {
      on: {
        SELECT: "track",
        MARK: "markers",
        LOCATION: "locations",
        FENCE: "geofences",
        TRIP: "replay",
        NAVIGATE: "navigate",
      },
    },
    track: {
      on: {
        DESELECT: "scan",
        SELECT: "track",
      },
    },
    markers: {
      on: {
        DESELECT: "scan",
      },
    },
    locations: {
      on: {
        CANCEL: "scan",
      },
    },
    routes: {
      on: {
        DESELECT: "scan",
        SELECT: "route",
        TRIP: "replay",
      },
    },
    route: {
      on: {
        DESELECT: "scan",
      },
    },
    geofences: {
      on: {
        DESELECT: "scan",
      },
    },
    replay: {
      on: {
        DESELECT: "scan",
        VIEW: "route",
      },
    },
    navigate: {
      on: {
        DESELECT: "scan",
        TRIP: "replay",
      },
    },
  },
});

export default mapMachine;
